export const STUDENT_DASHBOARD = '/dashboard'
